import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ValueLabelOption } from "../../types/commonTypes";
import { CheckboxCheck, CheckboxItem, CheckboxLabel, CheckboxLabelContainer, CheckboxSubLabel } from "../styled/Checkbox.style";

interface CheckboxItemCmpProps<T> {
    item: ValueLabelOption<T>;
    itemClassName?: string;
    onSelect: any;
    isActive?: boolean;
    horizontal?: boolean;
    companyName?: string;
}

/* istanbul ignore next */
const CheckboxItemCmp = <T extends unknown>(props: CheckboxItemCmpProps<T>) => {
    const { item, itemClassName, onSelect, isActive, horizontal, companyName } = props
    const isActiveClass = isActive ? 'active' : ''
    const showIcon = (companyName !== "LINEAR" || isActive)
    return (
        <CheckboxItem
            className={`${itemClassName} ${companyName}`}
            horizontal={horizontal}>
            <CheckboxCheck
                className={`${isActiveClass} ${itemClassName} ${companyName}`}
                onClick={() => onSelect(item)}>
                {showIcon && <FontAwesomeIcon icon={faCheck} />}
            </CheckboxCheck>
            <CheckboxLabelContainer>
                <CheckboxLabel
                    light={true}
                    horizontal={horizontal}
                    className={`${itemClassName} ${companyName}`}>{item.label}
                </CheckboxLabel>
                <CheckboxSubLabel className={companyName}>{item.subLabel}</CheckboxSubLabel>
            </CheckboxLabelContainer>
        </CheckboxItem>
    )
}

export default CheckboxItemCmp